export enum ReparabilityThemesEnum {
  red = 'red',
  orange = 'orange',
  yellow = 'yellow',
  green = 'green',
  darkGreen = 'dark-green'
}
